module.exports = __webpack_public_path__ + "static/media/paypal.32b83193.svg";